module.exports = __webpack_public_path__ + "static/media/s_v10_t3.db3b9ce2.mp3";